/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * Copyright (c) 2013 MOCA Systems, Inc.  All rights reserved.
 *
 *
 *
 *
 */
'use strict';

import * as angular from 'angular';
import { Role } from '@touchplan/common';

angular
	.module('ticketspaceApp.filters', [])

	.filter('arrangeSidebar', function () {
		return function (input, arg1) {
			let out = [];
			if (!arg1) {
				return input;
			}
			if (!input) {
				return input;
			}
			for (let i = 0; i < arg1.length; i++) {
				for (let j = 0; j < input.length; j++) {
					if (arg1[i] == input[j].id) {
						out.push(input[j]);
					}
				}
			}
			return out;
		};
	})

	.directive('subElement', function ($http) {
		return {
			restrict: 'A',
			link(scope: any, element, attrs) {
				scope.contentUrl = attrs.subElement;
			},
			template: '<div data-element-type="none" ng-include="contentUrl"></div>',
			replace: true,
			scope: false,
		};
	})

	// This certainly could be more generalized.  The assumption is you pass in
	// an object that is a collection of roles.  This filter will return an object
	// the is the collection filtered down to ones that have a rolename that matches
	// the string passed in.  For extra credit we make the match case insensitive
	.filter('filterByRoleName', function () {
		return function (items, searchText) {
			// if searchText is undefined, punt and just return the object unfiltered
			if (typeof searchText == 'undefined') {
				return items;
			} else {
				// we have a string, filter by it
				searchText = searchText.toLowerCase();
				let result = {};
				angular.forEach(items, function (value, key) {
					if (items[value].roleName.toLowerCase().indexOf(searchText) >= 0) {
						result[key] = items[value];
					}
				});
				return result;
			}
		};
	})

	.filter('spanses', function ($sce) {
		return function (text) {
			let cumulative = '';
			for (let i = 0; i < text.length; i++) {
				cumulative += '<span>' + text[i] + '</span>';
			}
			return $sce.trustAs('html', cumulative);
		};
	})

	.filter('toArray', function () {
		return function (obj) {
			if (!obj) {
				return [];
			}
			return Object.keys(obj).map((key) => {
				return obj[key];
			});
		};
	})

	.filter('projectSort', [
		'$filter',
		function ($filter) {
			return function (input, orderbyProp, last, useLast) {
				if (useLast) {
					return last.list;
				}
				last.list = $filter('orderBy')(input, orderbyProp);
				return last.list;
			};
		},
	])

	.filter('hasRole', function () {
		return function (roleId: string, roles: Role[]): boolean {
			if (!roleId) {
				return false;
			}
			return !!roles.find((role) => role.$id === roleId);
		};
	});
